import React from "react";
import styled from "styled-components";

const Button = styled.button`
  ${(p) => p.theme.typography.tXSmall};
  display: ${(p) => (p.width === "100%" ? "flex" : "inline-flex")};
  width: ${(p) => (p.width === "auto" ? "auto" : `calc(${p.width} - 5px)`)};
  margin: ${(p) => {
    switch (p.width) {
      case "100%":
        return "0 0 5px 0";
      case "auto":
        return "0 10px 10px 0";
      default:
        return "0 5px 5px 0";
    }
  }};
  justify-content: ${(p) => (p.width === "100%" ? "space-between" : "center")};
  align-items: center;
  line-height: 1em;
  height: 30px;
  padding: 10px;
  border: solid 1px ${(p) => p.theme.colors.ltGreen};
  background-color: ${(p) =>
    p.active ? p.theme.colors.ltGreen : "transparent"};
  transition: color 200ms cubic-bezier(0.25, 0.1, 0.25, 1),
    background-color 200ms cubic-bezier(0.25, 0.1, 0.25, 1);

  &:last-child {
    margin: 0;
  }

  span {
    display: inline-block;
    vertical-align: bottom;

    &[class*="icon-"] {
      margin: 0 0 0 12px;
      font-size: 9px;
      display: ${(p) => (p.active ? "block" : "none")};
    }
  }
`;

const Tag = ({ text, ...props }) => {
  props.width ||= "auto";

  return (
    <Button {...props}>
      <span>{text}</span>
      <span className="icon-close"></span>
    </Button>
  );
};

export default Tag;
